import { Component, SimpleChanges, ElementRef, ViewChild, Input, AfterViewInit, OnChanges } from '@angular/core';

@Component({
  selector: 'animated-counter',
  standalone: false,
  templateUrl: './animated-counter.component.html',
  styleUrls: ['./animated-counter.component.scss']
})
export class AnimatedCounterComponent implements AfterViewInit, OnChanges {

  duration: number = 1000;
  previousDigit: number = 0;

  @Input() digit: number;
  @Input() steps: number;
  @ViewChild('animatedDigit') animatedDigit: ElementRef;

  animateCount() {

    // Check to see if the digit given is of type number and the required element is not undefined.
    if (typeof this.digit === 'number' && this.animatedDigit !== undefined) {
      this.counterFunc(this.digit, this.duration, this.animatedDigit);
    }

    // Record the current digit as the previous
    this.previousDigit = this.digit;
  }


  counterFunc(endValue, durationMs, element) {

    // This function uses sin and animation frame
    // to calculate an ease in and out looking number counter.
    // https://www.wolframalpha.com/input/?i=integrate+sin+x+dx+from+x%3D0+to+pi : Just for show 0 => PI sin(x)
    // It kinda does...

    if (!this.steps) {
      this.steps = 12;
    }

    const stepCount = Math.abs(durationMs / this.steps);
    const valueIncrement = (endValue - this.previousDigit) / stepCount;
    const sinValueIncrement = Math.PI / stepCount;

    let currentValue = this.previousDigit;
    let currentSinValue = 0;

    // The animation step occurs here.
    function step() {
      currentSinValue += sinValueIncrement;
      currentValue += valueIncrement * Math.sin(currentSinValue) ** 2 * 2;

      element.nativeElement.textContent = Math.abs(Math.floor(currentValue));

      if (currentSinValue < Math.PI) {
        window.requestAnimationFrame(step);
      } else {
        element.nativeElement.textContent = Math.abs(Math.floor(endValue));
      }
    }

    step();
  }

  ngAfterViewInit() {
    if (this.digit) {
      this.animateCount();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['digit']) {
      this.animateCount();
    }
  }
}
